import React from 'react';

function Footer() {
  return (
    <footer className="module bg-light">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
